import React, { useCallback, useContext, useEffect, useState } from "react";
import { Spin, message, Input } from "antd";
import { LoadingOutlined } from "@/utils/antdIcon";
import { LoginFormContext, LoginFormContextType } from "../../utils";
import IconFont, { IconArrowRight, IconGroup, IconJoyMeetingGroup } from "@/components/icon";
import SelectTeam from "./SelectTeam";
import JoinOtherTeam from "./JoinOtherTeam";
import CreateTeam from "./CreateTeam";
import { BackNav } from "../../comps";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { ApprovaTeamUserInfoList, InviteUserInfo, TeamUserInfo } from "@/types/LoginPage";
import { useTranslation } from "react-i18next";
import { getWebEnvObj } from "@/utils";
import JoinPersonalTeam from "./JoinPersonalTeam";
import JoinTeam from "./JoinTeam";
import styles from '../../index.module.less'
const {
  REACT_APP_OSS_BASE_URL = "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com"
} = getWebEnvObj();
const teamBgImg = `${REACT_APP_OSS_BASE_URL}/statics/images/team_bg.png`;
enum JoinPath {
  Init,
  JoinOtherTeam,
  CreateTeam,
  JoinPersonalTeam
}
// 没有用过
function EntryItem({
  title,
  desc,
  styles,
  icon,
  clickHandle
}: {
  styles: any;
  title: string;
  desc?: string;
  icon: any;
  clickHandle: () => void;
}) {
  return (
    <div
      style={{
        backgroundPosition: "top right",
        backgroundSize: "99px 47px",
        // backgroundImage: `url(${teamBgImg})`,
        backgroundRepeat: "no-repeat"
      }}
      className={`${desc} ? ${styles["entry-hover"]} : (${styles["entry-hover"]} ${styles.noDesc})`}
      onClick={clickHandle}
    >
      <div style={{ marginRight: "32px" }}>
        <p
          style={{
            textAlign: "left"
          }}
        >
          {/* {icon} */}
          <span className={styles.title} style={{ ...styles }}>
            {title}
          </span>
        </p>
        {desc && <p className={styles.desc}>{desc}</p>}
      </div>
      {IconArrowRight}
    </div>
  );
}

export default function JoinMeForm({
  onSelectTeam,
  showActive
}: {
  onSelectTeam: (teamId: string) => void;
  showActive: (team: TeamUserInfo) => void;
}) {
  const { service, appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const {
    navigate,
    onMobileChange,
    setResendLastTs,
    authInfo,
    enterApplication
  } = React.useContext<LoginFormContextType>(LoginFormContext);
  const { t } = useTranslation("common");
  const [loading, setLoading] = React.useState(false);
  const [joinPath, setJoinPath] = useState(JoinPath.Init);
  const loadingComp = (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: "white" }} spin />} />
  );
  // 有！
  if (!authInfo.teamUserInfoList.length) {
    return (
      <div className={styles.mobileForm}>
        <JoinTeam />
      </div>
    );
  }
  if(authInfo.teamUserInfoList.length) {
    return (
      <SelectTeam
        teamUserInfoList={authInfo.teamUserInfoList}
        onSelectTeam={onSelectTeam}
        showActive={showActive}
      />
    );
  }
  return null;
}
